import React, { Component } from 'react';

class MembersLinks extends Component {
  render() {

    const downloadLinks =
      <div style={{
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'inline-block',
          marginRight: '40px'
        }}>
          <a href={process.env.PUBLIC_URL + "/docs/MPC_internal_competition_Guidelines_v5_2014_15.pdf"} download>Competition Guidelines</a>
        </div>
        <div style={{
          display: 'inline-block'
        }}>
          <a href={process.env.PUBLIC_URL + "/docs/Constitution 2020.pdf"} download>Constitution</a>
        </div>
      </div>;

    return (
      <div className="links">
        <h5>Members Links</h5>
        {downloadLinks}
      </div>
    );
  }
}

export default MembersLinks;



// WEBPACK FOOTER //
// ./src/components/membersLinks.jsx